export const CUSTOM_EVENT_IDS = {
  ChangeUserBalance: 'change-user-balance',
  CasinoNavbarCLick: 'casino-navbar-click',
};

export const IFRAME_EVENTS_DATA_TYPES = {
  ChangeBalance: 'casino-eva:host-update-user-balance',
};
